import { useQuery } from '@apollo/client/react';
import { HOMEPAGE_QUERY } from '../../graphql/home-queries';

export default function useGetHomePage() {
    const { data, loading } = useQuery(HOMEPAGE_QUERY);
    return { homePage: data?.homePage, loading };
}
